<template>
  <div class="iiko-access-modal" @keydown.esc="close">
    <remove-access-modal ref="removeAccessModal" @remove="onRemove"></remove-access-modal>

    <c-sidesheet :active="active" :title="title" @close="close">
      <template #actions>
        <c-button
          v-if="access"
          class="iiko-access-modal__remove"
          size="small"
          label="Удалить"
          :icon="{ icon: 'trash', color: 'secondary' }"
          @click="remove"
        />
      </template>

      <div class="iiko-access-form">
        <div class="iiko-access-form__container">
          <div class="row">
            <div class="col col-12">
              <c-input
                v-model="form.terminalName"
                class="iiko-access-form__field"
                :class="{
                  'iiko-access-form__field--invalid': terminalNameError,
                }"
                floating-label="Название терминала"
                :clearable="true"
                :max-length="255"
                :required="terminalNameError"
                :required-message="terminalNameError"
              ></c-input>
            </div>
            <div class="col col-12 col-md-6">
              <c-input
                v-model="form.terminalId"
                class="iiko-access-form__field"
                :class="{
                  'iiko-access-form__field--invalid': terminalIdError,
                }"
                floating-label="ID терминала (IIKO)"
                :clearable="true"
                :required="terminalIdError"
                :required-message="terminalIdError"
                :max-length="255"
              ></c-input>
            </div>
            <div class="col col-12 col-md-6">
              <c-input
                v-model="form.host"
                class="iiko-access-form__field"
                :class="{
                  'iiko-access-form__field--invalid': hostError,
                }"
                floating-label="Хост"
                :clearable="true"
                :required="hostError"
                :required-message="hostError"
                :max-length="255"
              ></c-input>
            </div>

            <div class="col col-12 col-md-6">
              <c-input
                v-model="form.login"
                class="iiko-access-form__field"
                :class="{
                  'iiko-access-form__field--invalid': loginError,
                }"
                floating-label="Логин"
                :clearable="true"
                :required="loginError"
                :required-message="loginError"
                :max-length="255"
              ></c-input>
            </div>

            <div class="col col-12 col-md-6">
              <c-input
                ref="password"
                v-model="form.password"
                class="iiko-access-form__field"
                :class="{
                  'iiko-access-form__field--invalid': passwordError,
                }"
                floating-label="Пароль"
                type="password"
                :required="passwordError"
                :required-message="passwordError"
                :max-length="255"
              ></c-input>
            </div>
          </div>

          <div class="iiko-access-form__actions">
            <c-button size="large" class="iiko-access-form__reset" label="Отменить" @click="close" />

            <c-button
              class="iiko-access-form__save"
              label="Сохранить"
              :disabled="!hasData"
              color="primary"
              size="large"
              @click="submit"
            />
          </div>
        </div>
      </div>
    </c-sidesheet>
  </div>
</template>

<script>
import CSidesheet from "@/components/sidesheet";
import CInput from "@/components/controls2/Input";
import CButton from "@/components/controls2/Button";
import RemoveAccessModal from "../remove-access-modal";

export default {
  components: {
    CSidesheet,
    CInput,
    CButton,
    RemoveAccessModal,
  },

  data() {
    return {
      access: null,
      id: null,
      active: false,
      form: {
        terminalName: "",
        terminalId: "",
        host: "",
        login: "",
        password: "",
      },
      submitted: false,
    };
  },

  computed: {
    title() {
      return this.access ? "Редактирование доступа" : "Новый доступ";
    },

    terminalNameError() {
      if (!this.submitted) return null;
      if (!this.form.terminalName.trim()) return "Обязательное поле";
      return null;
    },

    terminalIdError() {
      if (!this.submitted) return null;
      if (!this.form.terminalId.trim()) return "Обязательное поле";
      return null;
    },

    hostError() {
      if (!this.submitted) return null;
      if (!this.form.host.trim()) return "Обязательное поле";
      return null;
    },

    loginError() {
      if (!this.submitted) return null;
      if (!this.form.login.trim()) return "Обязательное поле";
      return null;
    },

    passwordError() {
      if (!this.submitted) return null;
      if (!this.access && !this.form.password.trim()) return "Обязательное поле";
      return null;
    },

    isValid() {
      return (
        !this.terminalNameError && !this.terminalIdError && !this.hostError && !this.loginError && !this.passwordError
      );
    },

    hasData() {
      return this.form.terminalName || this.form.terminalId || this.form.host || this.form.login || this.form.password;
    },
  },

  watch: {
    "form.password": function (v) {
      console.log("change pass", v);
    },
  },

  created() {
    document.getElementsByTagName("body")[0].addEventListener("click", () => {
      this.$root.$emit("bv::hide::popover");
    });

    document.addEventListener("keyup", (evt) => {
      if (evt.keyCode === 27) {
        if (this.active) {
          this.close();
        }
      }
    });
  },

  methods: {
    open(access) {
      this.reset();

      if (access) {
        this.access = access;

        this.form.terminalId = access.terminal_id;
        this.form.terminalName = access.name;
        this.form.host = access.host;
        this.form.login = access.login;
        this.form.password = access.password || "";
      }

      this.active = true;
    },
    close() {
      this.active = false;
      this.$emit("close");
    },
    remove() {
      this.$refs.removeAccessModal.open(this.access);
    },
    onRemove() {
      this.close();
      this.$nextTick(() => this.$emit("remove", this.access));
    },
    getParams() {
      const params = {
        terminalName: this.form.terminalName,
        terminalId: this.form.terminalId,
        host: this.form.host,
        login: this.form.login,
        password: this.form.password,
      };

      if (this.access) params.id = this.access.id;

      return params;
    },
    submit() {
      this.submitted = true;
      if (!this.isValid) return;

      const action = this.access ? "referenceIiko/updateAccess" : "referenceIiko/createAccess";

      this.$store
        .dispatch(action, this.getParams())
        .then((res) => {
          if (res.success) {
            this.submitted = false;
            this.close();
            this.$nextTick(() => this.$emit(this.access ? "updated" : "created", res.model));
          } else {
            console.error(res);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    reset() {
      this.submitted = false;
      this.access = null;

      this.form.terminalId = "";
      this.form.terminalName = "";
      this.form.host = "";
      this.form.login = "";
      this.form.password = "";

      this.$refs.password.$el.querySelector("input").value = "";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

/deep/ .sidesheet {
  &__header {
    margin-bottom: 28px;
  }

  @include onlyStandartMobile {
    .sidesheet__wrapper {
      overflow: auto;

      &::-webkit-scrollbar {
        width: 4px;
        height: 100%;
      }

      &::-webkit-scrollbar-thumb {
        background: $color-secondary;
        border-radius: 4px;
      }

      &::-webkit-scrollbar-track {
        background: $color-border-alt;
      }

      .iiko-access-form__actions {
        opacity: 0;
        transition: opacity 500ms;
      }

      &.sidesheet__wrapper_active {
        .iiko-access-form__actions {
          background: white;
          position: fixed;
          opacity: 1;
          bottom: 0;
          left: 0;
          right: 0;

          .c-button {
            width: 50%;
            margin: 0;
            border-radius: 0;
          }
        }
      }
    }
    .sidesheet__title {
      font-size: 18px;
    }
    .sidesheet__close {
      margin-bottom: 0;
    }
    .sidesheet__header {
      display: block;
    }
    .iiko-access-modal__remove {
      margin-top: 14px;
    }
  }
}
.iiko-access-form {
  &__container {
    max-width: 764px;
  }
  &__field {
    margin-bottom: 24px;

    &--invalid {
      margin-bottom: 44px;
    }
  }
  &__actions {
    display: flex;
    align-items: center;
  }
  &__reset {
    margin-right: 10px;
  }

  @include onlyStandartMobile {
    &__container {
      padding-bottom: 40px;
    }
  }
}
</style>
